import { default_pods_input_state_smart_get, virtel_schema_smart_get } from "./ter-virtel-definition-lib";
import { _get_fixed_fields } from "./ter-virtel-utils";
import { _getParamsFromLib } from "./ter-params-utils";
import { js_utils } from "../utils/frfr-js-utils";
import { _derivatPoluproizvod_panel_naziv, derivatZaPanelIzmenjivaca, _derivat_panel_lim_spoljasnji, _derivat_panel_lim_unutrasnji, derivatPoluproizvod_panel_korigovane_dimenzije_nakon_unosa, derAutoCreateVirbom_terkk_panel_prepare_vir_input, derAutoCreateVirbom_terkk_panel_children, derivatPoluproizvod_panel_korigovane_dimenzije_iz_virtela_u_draftel } from "./ter-derivat-lib-terkk-panel";
import { virbomCounter } from "../utils/frfr-virbom-counter-utils";
import { _virbom_manipulator } from "../utils/frfr-virbom-manipulator-utils";
import { _enrich_virtel_from_unbundled_subDraftel_arr_with_fresh_subkey } from "./ter-virbom-datarender";
import { _ploca_glikolnog_rekuperatora_limcustom_bundleDraftel_make } from "./ter-derivat-lib-terkk-panel-extra";
import { draftel_codecs_pack_terkk$_bundle_limcustom } from "./ter-draftel-codec-lib-terkk-bundle-limcustom";


// TER DRAFTEL CODECS LIB

/*

*/


export const draftel_codecs_pack_terkk$_bundle_panel = {};


// ---------- CODEC SCHEMA METHODS ----------


draftel_codecs_pack_terkk$_bundle_panel.default_preset_state = () => {
  const preset_state = {
    _draftelschemakey: 'terkk$_bundle_panel',
    terkknivo: 'CHILDOFMODUL', // ???
    // ID polje ne ide u preset, dobija se samo u EDIT MODE ali i tada mora biti obezbedjeno

    _subform_arr: [], // SUBFORM ARR

    "flag_custom_pods_input": false, // flag_custom_pods_input is false by default

    // pods_input za bundle nepotreban jer se koristi widget za pods_input
    // tipkomore: null,

    sistempanela: 'novisistem',
    // tipunosapanela: 'GOTOV_PANEL',
    tipunosapanela: null, // DL 2024-02-27: Potrebno je da prilikom rucnog unosa panela opciju tip unosa bude obavezno polje i podrazumevano prazano.

    flag_ter_special_1po1: true, // za unos 1 po 1 u sastavnici // NJ 2024-10-11: Kvačicu možeš da staviš kao default-no uključenu.

    // materijali NOVO 2024-01-22
    panel_materijal_lim_spoljasnji: null,
    panel_materijal_lim_unutrasnji_redovni: null,
    panel_materijal_lim_unutrasnji_redovni_podni: null,
    panel_materijal_lim_unutrasnji_hygiene_prohrom: null,
    panel_materijal_lim_unutrasnji_hygiene_plastificirani: null,
    panel_materijal_lim_unutrasnji_hygiene_podni: null,
    panel_materijal_lim_spoljasnji_panelbezprofila: null,
    panel_materijal_lim_unutrasnji_panelbezprofila: null,
  };
  return preset_state;
};


draftel_codecs_pack_terkk$_bundle_panel.default_pods_input_state = () => {
  /*
  return {
    tipkomore: null,
  };
  */
  return default_pods_input_state_smart_get('terkk$panel');
};



draftel_codecs_pack_terkk$_bundle_panel.default_subform_item_preset_state = () => {
  const preset_state = {
    _draftelschemakey: 'terkk$panel',
    terkknivo: 'CHILDOFMODUL', // ???
    // ID polje ne ide u preset, dobija se samo u EDIT MODE ali i tada mora biti obezbedjeno

    "flag_custom_pods_input": false, // flag_custom_pods_input is false by default

    sistempanela: 'novisistem',
    tipunosapanela: 'GOTOV_PANEL',

    ////
    tippanela: null,
    _sirina: null,
    _visina: null,
    kolicina: null,
    x1: null,
    y1: null,
    d1: null,
    x2: null,
    y2: null,
    d2: null,
    a: null,
    b: null,
    a2: null,
    b2: null,
    c: null,
    d: null,
    e: null,
    f: null,
    eliminatorkapi: null,
    smervazduha: null,
    // revizioniotvor: null,
    revizioniotvor: "NE", // DL 2023-11-02: da bude po defaultu NE
    kljuc: null,
    sigurnosnabrava: null,
    panel_rucicarukohvat: null, //
    panel_rucicarukohvat_kolicina: null, //
    panel_rucicarukohvat_kolicina_preporucena: null, //
    panel_plocaglikolnogrekuperatora: "NE", // NJ 2024-12-04: a samo staviš defaultnu vrednost NE
    panel_lim_spoljasnji_tip: null, // TODO
    panel_lim_unutrasnji_tip: null, // TODO
  };
  return preset_state;
};


export const _terkk_panel_multiflag_tippanela_helper = (p) => {
  // TODO ovde treba da se odradi da zavisno od polja multiflag_tippanela da razlicita polja obrise
  // TODO Ako nisu vrata onda kljuc i sigurnosna brava treba da su Undefined pa cemo ovde da ih dodamo. Trebalo bi da napravimo vise razlicitih sema
  const multiflag_tippanela = p.tippanela;
  /*
  "name": "tippanela",
  "options": [
    { "title": "STANDARDNI", "value": "standardni" },
    { "title": "OPSLUZIONI", "value": "opsluzioni" },
    { "title": "PODNI", "value": "podni" },
    { "title": "OKRUGLI OTVOR x 1", "value": "okrugliotvor1" },
    { "title": "OKRUGLI OTVOR x 2", "value": "okrugliotvor2" },
    { "title": "PANEL IZMENJIVACA", "value": "panelizmenjivaca" },
    { "title": "KVADRATNI OTVOR", "value": "kvadratniotvor" },
    { "title": "KVADRATNI OTVOR x 2", "value": "kvadratniotvor2" },
    { "title": "VRATA", "value": "vrata" },
    { "title": "PANEL BEZ PROFILA", "value": "panelbezprofila" },
  ]
  */
  let x = {
    sirina: null,
    visina: null,
    kolicina: null,
    x1: null,
    y1: null,
    d1: null,
    x2: null,
    y2: null,
    d2: null,
    a: null,
    b: null,
    a2: null,
    b2: null,
    c: null,
    d: null,
    e: null,
    f: null,
    eliminatorkapi: null,
    smervazduha: null,
    kljuc: null,
    sigurnosnabrava: null,
    revizioniotvor: "NE", // DL 2023-11-02: da bude po defaultu NE
    panel_rucicarukohvat: null, //
    panel_rucicarukohvat_kolicina: null, //
    panel_rucicarukohvat_kolicina_preporucena: null, //
    panel_plocaglikolnogrekuperatora: "NE", // NJ 2024-12-04: a samo staviš defaultnu vrednost NE
  };
  // uvek idu sledeci
  x.tippanela = multiflag_tippanela;
  x.multiflag_tippanela = multiflag_tippanela; // ???
  x.sirina = p.sirina;
  x.visina = p.visina;
  x.kolicina = p.kolicina;
  x.panel_lim_spoljasnji_tip = p.panel_lim_spoljasnji_tip;
  x.panel_lim_unutrasnji_tip = p.panel_lim_unutrasnji_tip;
  // uvek idu i pods_input takodje
  x.tipkomore = p.tipkomore;
  x.unutrasnjaoplata = p.unutrasnjaoplata;
  x.tipispuneklimakomore = p.tipispuneklimakomore;
  x.vrstaprofila = p.vrstaprofila;
  // uslovno idu sledeci
  if (multiflag_tippanela === 'standardni') {
    x.revizioniotvor = p.revizioniotvor;
  }
  if (multiflag_tippanela === 'opsluzioni') {
    x.revizioniotvor = p.revizioniotvor;
    x.panel_rucicarukohvat = p.panel_rucicarukohvat;
    x.panel_rucicarukohvat_kolicina = p.panel_rucicarukohvat_kolicina;
    x.panel_rucicarukohvat_kolicina_preporucena = p.panel_rucicarukohvat_kolicina_preporucena;
    x.panel_plocaglikolnogrekuperatora = p.panel_plocaglikolnogrekuperatora;
  }
  if (multiflag_tippanela === 'podni') {
    // nema izuzetaka za podni tippanela
  }
  if (multiflag_tippanela === 'okrugliotvor1') {
    x.x1 = p.x1;
    x.y1 = p.y1;
    x.d1 = p.d1;
  }
  if (multiflag_tippanela === 'okrugliotvor2') {
    x.x1 = p.x1;
    x.y1 = p.y1;
    x.d1 = p.d1;
    x.x2 = p.x2;
    x.y2 = p.y2;
    x.d2 = p.d2;
  }
  if (multiflag_tippanela === 'panelizmenjivaca') {
    x.a = p.a;
    x.b = p.b;
    x.c = p.c;
    x.d = p.d;
    x.e = p.e;
    x.f = p.f;
    x.d1 = p.d1;
    x.d2 = p.d2;
    x.eliminatorkapi = p.eliminatorkapi;
    x.smervazduha = p.smervazduha;
  }
  if (multiflag_tippanela === 'kvadratniotvor') {
    x.x1 = p.x1;
    x.y1 = p.y1;
    x.a = p.a;
    x.b = p.b;
  }
  if (multiflag_tippanela === 'kvadratniotvor2') {
    x.x1 = p.x1;
    x.y1 = p.y1;
    x.a = p.a;
    x.b = p.b;
    x.x2 = p.x2;
    x.y2 = p.y2;
    x.a2 = p.a2;
    x.b2 = p.b2;
  }
  if (multiflag_tippanela === 'vrata') {
    x.kljuc = p.kljuc;
    x.sigurnosnabrava = p.sigurnosnabrava;
    x.revizioniotvor = p.revizioniotvor;
  }
  if (multiflag_tippanela === 'panelbezprofila') {
    // nema dodatnih polja za panelbezprofila
  }
  return x;
};



draftel_codecs_pack_terkk$_bundle_panel.keys_for_direct_cloning = [
  "flag_custom_pods_input",

  // pods_input 
  // "tipkomore",
  // "unutrasnjaoplata",
  // "tipispuneklimakomore",
  // "vrstaprofila",
  ...Object.keys(draftel_codecs_pack_terkk$_bundle_panel.default_pods_input_state()),

  "rev_id",
  "superkey",
  "subkey",
  "parent_subkey",
  "bomlevel_imported",
  ...Object.keys(draftel_codecs_pack_terkk$_bundle_panel.default_subform_item_preset_state())
];


// ---------- CODEC ENCODING  - DRAFTEL TO VIRBOM DIRECTION ----------


draftel_codecs_pack_terkk$_bundle_panel.subDrafel_to_virtel = (formState) => {
  // pretvara iz formState u virtel format sa ispravnim flagovima
  const sema = virtel_schema_smart_get('terkk$panel');
  console.log('formState', formState);
  let state = {
    ...formState,
    ...derivatPoluproizvod_panel_korigovane_dimenzije_nakon_unosa(formState._sirina, formState._visina, formState.tipunosapanela, formState.tippanela)
    // da l iovde treba dodati tipunosapanela: "GOTOV_PANEL", ???
  };
  let panel = state;
  //////
  // unutrasnja oplata je po defaultu plastificirano
  // a ako je komora higijenik, onda se bira unutrasnja oplata
  // const k = panel; // NOVO posto smo od k dobijali samo .tipkomore i .tipispuneklimakomore a sada su oni vec ukljuceni u draftel preko pods_input widgeta, ne treba nam vise k kao poseban argument.
  // panel.tipkomore = k.tipkomore;
  // if (k.tipkomore === 'HYGIENE:pro') {
  if (panel.tipkomore === 'HYGIENE:pro') {
    // panel.unutrasnjaoplata = k.unutrasnjaoplata;
    // ostaje od pods_input
  } else {
    // ako nije 'HYGIENE:pro' default je 'plastificirano'
    panel.unutrasnjaoplata = 'plastificirano'; // default pregazi pods_input
  };
  console.log('panel (+ k pods_input)', panel);

  if (panel.tippanela === 'panelizmenjivaca') {
    let panelIzmenjivacaDodatniPodaci = derivatZaPanelIzmenjivaca(panel);
    panel = {
      ...panel,
      ...panelIzmenjivacaDodatniPodaci
    };
  };
  // dopunjavanje panela
  /*
  if (k.tipispuneklimakomore) {
    panel.tipispuneklimakomore = k.tipispuneklimakomore; // ???
  };
  */
  // let _panel_dopunjen = derivatPoluproizvod_panel_dopuni(panel, k);
  console.log('* panel', panel);
  // panel.naziv = _derivatPoluproizvod_panel_naziv(panel, k.tipkomore, panel.unutrasnjaoplata, k.tipispuneklimakomore, true);
  panel.naziv = _derivatPoluproizvod_panel_naziv(panel, panel.tipkomore, panel.unutrasnjaoplata, panel.tipispuneklimakomore, true);
  const _der_lim_spolj = _derivat_panel_lim_spoljasnji(panel); // NOVO 2024-01-22
  panel.panel_lim_spoljasnji_tip = _der_lim_spolj.tip;
  // const _der_lim_unutr = _derivat_panel_lim_unutrasnji(panel.tippanela, panel.tipkomore, panel.unutrasnjaoplata);
  const _der_lim_unutr = _derivat_panel_lim_unutrasnji(panel); // NOVO 2024-01-22
  panel.panel_lim_unutrasnji_tip = _der_lim_unutr.tip;
  //
  let _panel_params = {};
  // if (formState.tippanela === 'vrata') {
  if (formState.tippanela === 'vrata' || formState.revizioniotvor === "DA") { // NOVO 2024-04-08
    _panel_params = {
      ..._getParamsFromLib("terkk$panel_tip_vrata")
    };
  } else {
    _panel_params = {
      ..._getParamsFromLib("terkk$panel_tip_not_vrata")
    };
  }
  ////
  const state2 = {
    virtelschemakey: 'terkk$panel',
    ...panel,
    ..._get_fixed_fields(sema),
    ..._panel_params // parametri na kraju imaju prioritet
  };
  return state2; // return virtel
};


draftel_codecs_pack_terkk$_bundle_panel.bundleDraftel_to_unbundled_subDraftel_arr = (bundleDraftel) => {
  // draftel single BUNDLE to draftel array
  const bundle = bundleDraftel;
  let _unbundled_subDraftel_arr = [];
  const zajednicki_props_za_items = {
    parent_subkey: bundle.parent_subkey,
    superkey: bundle.superkey,
    sistempanela: bundle.sistempanela,
    tipunosapanela: bundle.tipunosapanela,
    // pods_input TODO Da li treba bolje resenje?
    flag_custom_pods_input: bundle.flag_custom_pods_input,
    tipkomore: bundle.tipkomore,
    unutrasnjaoplata: bundle.unutrasnjaoplata,
    tipispuneklimakomore: bundle.tipispuneklimakomore,
    vrstaprofila: bundle.vrstaprofila,
    _extra_siframodula: bundle._extra_siframodula, // NOVO 2025-03-18
    //
    panel_materijal_lim_spoljasnji: bundle.panel_materijal_lim_spoljasnji,
    panel_materijal_lim_unutrasnji_redovni: bundle.panel_materijal_lim_unutrasnji_redovni,
    panel_materijal_lim_unutrasnji_redovni_podni: bundle.panel_materijal_lim_unutrasnji_redovni_podni,
    panel_materijal_lim_unutrasnji_hygiene_prohrom: bundle.panel_materijal_lim_unutrasnji_hygiene_prohrom,
    panel_materijal_lim_unutrasnji_hygiene_plastificirani: bundle.panel_materijal_lim_unutrasnji_hygiene_plastificirani,
    panel_materijal_lim_unutrasnji_hygiene_podni: bundle.panel_materijal_lim_unutrasnji_hygiene_podni,
    panel_materijal_lim_spoljasnji_panelbezprofila: bundle.panel_materijal_lim_spoljasnji_panelbezprofila,
    panel_materijal_lim_unutrasnji_panelbezprofila: bundle.panel_materijal_lim_unutrasnji_panelbezprofila,
  };
  if (Array.isArray(bundle._subform_arr)) {
    bundle._subform_arr.forEach(panel_raw => {
      const panel_raw_2 = {
        ...draftel_codecs_pack_terkk$_bundle_panel.default_subform_item_preset_state(),
        ...panel_raw,
        // ...derivatPoluproizvod_panel_korigovane_dimenzije_nakon_unosa(panel_raw._sirina, panel_raw._visina, zajednicki_props_za_items.tipunosapanela, panel_raw.tippanela)
      };
      let draftel_panel = {
        ..._terkk_panel_multiflag_tippanela_helper(panel_raw_2),
        // multiflag_tippanela: multiflag_tippanela,
        // tippanela: multiflag_tippanela,
        // virtelschemakey: 'terkk$_bundle_panel',
        // _draftelschemakey: 'terkk$_bundle_panel',
        _sirina: panel_raw_2._sirina,
        _visina: panel_raw_2._visina,
        bomlevel_imported: panel_raw_2.bomlevel_imported,
        ...zajednicki_props_za_items
      };
      //
      // _unbundled_subDraftel_arr.push(draftel_panel);
      if (bundle.flag_ter_special_1po1 === true && draftel_panel.kolicina > 1) {
        // CASE speical da u ssatvnicu idu 1po1 panel
        for (let i = 0; i < draftel_panel.kolicina; i++) {
          const _rastavljen_za_1po1 = {
            ...draftel_panel,
            kolicina: 1
          };
          _unbundled_subDraftel_arr.push(_rastavljen_za_1po1);
        }
      } else {
        _unbundled_subDraftel_arr.push(draftel_panel);
      }
    });
  };
  return _unbundled_subDraftel_arr;
};


draftel_codecs_pack_terkk$_bundle_panel.bundleDrafel_to_virbom = (bundleDraftel) => {
  // MAIN CONVERT METHOD
  // const sema = virtel_schema_smart_get('terkk$_bundle_panel');

  let virbom_ref = _virbom_manipulator.init(virbomCounter.generateFreshSubkey);

  // rastavljamo bundle na pojedinacne p pomocu codec-a
  let paneliArr = draftel_codecs_pack_terkk$_bundle_panel.bundleDraftel_to_unbundled_subDraftel_arr(bundleDraftel);
  console.log('PENEL unbundled_draftel_arr', paneliArr);
  // Sad prodjem kroz unbundleovani array i spakujem svaki kao ostale poluproizvode
  paneliArr.forEach((panel, index) => {
    // KORAK poluproizvod level 3 virtel
    // novonastali elementi raspakovani iz bundlea i oni jos uvek nemaju svoje ID-ove. Sada je potrebno da im dodelimo ID pomocu _enrichWithFreshSubkey()
    // graphlevel: 3,
    let virtel_panel = _enrich_virtel_from_unbundled_subDraftel_arr_with_fresh_subkey({
      ...draftel_codecs_pack_terkk$_bundle_panel.subDrafel_to_virtel(panel),
      // virtelschemakey: 'terkk$panel',
    });
    console.log('virtel_panel', virtel_panel);
    // zatim preuzimamo taj novi ID da bi children elementi koji slede imali za parent_subkey.
    const local_graphlevel = 1;
    // _virbom_manipulator.add_on_graphlevel(virbom_ref, virtel_panel, 3);
    _virbom_manipulator.add_on_graphlevel(virbom_ref, virtel_panel, local_graphlevel);

    let p = virtel_panel;

    // KORAK pripreme derivata za
    let pods_input_za_derivate = derAutoCreateVirbom_terkk_panel_prepare_vir_input(p);
    let _derivati = derAutoCreateVirbom_terkk_panel_children(pods_input_za_derivate);
    console.log('_derivati panel');
    console.log(_derivati);
    // USISAVANJE
    _virbom_manipulator._merge_virbom_into_virbom_on_graphlevel(virbom_ref, _derivati, local_graphlevel + 1, virbomCounter.generateFreshSubkey);


    // SPECIAL EXTRA STEPS
    if (p.tippanela === 'opsluzioni' && p.panel_plocaglikolnogrekuperatora === "DA") {
      //
      const _ploca_glikolnog_rekuperatora_limcustom_bundledraftel = _ploca_glikolnog_rekuperatora_limcustom_bundleDraftel_make(p);
      const _virbom_ploca_glikolnog_rekuperatora = draftel_codecs_pack_terkk$_bundle_limcustom.bundleDrafel_to_virbom(_ploca_glikolnog_rekuperatora_limcustom_bundledraftel);
      // USISAVANJE
      _virbom_manipulator._merge_virbom_into_virbom_on_graphlevel(virbom_ref, _virbom_ploca_glikolnog_rekuperatora, local_graphlevel, virbomCounter.generateFreshSubkey);
    }


    // ***ZAVRSENI KORACI ZA JEDAN pp3

  }); // end of eliminatorKapiArr foreach

  // ZAVRSENI KORACI ZA JEDAN pp3

  const virbom_seq = _virbom_manipulator.deinit(virbom_ref);
  return virbom_seq; // return virbom
};


// ---------- CODEC DECODING - VIRBOM TO DRAFTEL DIRECTION ----------


draftel_codecs_pack_terkk$_bundle_panel.virtel_to_subDraftel = (virtel) => {
  // pretvara iz virtela u formState format
  let state = {
    ...draftel_codecs_pack_terkk$_bundle_panel.default_subform_item_preset_state(),
    ...js_utils.clone_obj_but_only_selected_keys(virtel, draftel_codecs_pack_terkk$_bundle_panel.keys_for_direct_cloning),
    // tipunosapanela: "GOTOV_PANEL", // neophodno jer iz virtela uvek dolaze prave dimenzije ???
    // _sirina: virtel.sirina, // prave dimenzije
    // _visina: virtel.visina, // prave dimenzije
    ...derivatPoluproizvod_panel_korigovane_dimenzije_iz_virtela_u_draftel(virtel.sirina, virtel.visina, virtel.tipunosapanela, virtel.tippanela)
  };
  return state;
};


draftel_codecs_pack_terkk$_bundle_panel._virtelArr_to_bundleDraftel = (virtel_panel_arr, _generate_fresh_subkey, _generateFreshTempkey) => {
  // virtel paneli arr to single draftel _bundle_panel
  // bundle panel ne treba bundle_id jer svi paneli od jednog projekta koji pripadaju jednom modulu su uvek jedan bundle. Dakle za bundlovanje se koristi parent_subkey (to je id parent modula).
  //
  console.log('CODEC MAKE BUNDLE _virtelArr_to_bundleDraftel() - virtel_panel_arr:', virtel_panel_arr);
  // console.log(virtel_panel_arr);
  let parent_subkey_arr = [];
  virtel_panel_arr.forEach((item) => {
    if (parent_subkey_arr.includes(item.parent_subkey)) {
      // parent_subkey vec dodat
    } else {
      parent_subkey_arr.push(item.parent_subkey);
    }
  });
  //
  let bundle_arr = [];
  parent_subkey_arr.forEach((parent_subkey) => {
    // za svaki modul pravimo jedan _bundle_panel
    let _subform_arr = [];
    const bundle_id = _generate_fresh_subkey();
    virtel_panel_arr.forEach(virtel => {
      if (virtel.parent_subkey === parent_subkey) {
        const draftel_item = {
          ...draftel_codecs_pack_terkk$_bundle_panel.virtel_to_subDraftel(virtel),
          tempkey: _generateFreshTempkey(),
        };
        _subform_arr.push(draftel_item);
      }
    });
    console.log('_subform_arr', _subform_arr);
    if (js_utils.is_object(_subform_arr[0])) {
      const _first_item = _subform_arr[0];
      console.log('_first_item', _first_item);
      let bundleDraftel = {
        // _draftelschemakey: 'terkk$_bundle_panel',
        ...draftel_codecs_pack_terkk$_bundle_panel.default_preset_state(),
        _subform_arr: _subform_arr,
        parent_subkey,
        subkey: bundle_id,
        sistempanela: _first_item.sistempanela,
        tipunosapanela: _first_item.tipunosapanela,
        // pods_input TODO Da li treba bolje resenje?
        flag_custom_pods_input: _first_item.flag_custom_pods_input,
        tipkomore: _first_item.tipkomore,
        unutrasnjaoplata: _first_item.unutrasnjaoplata,
        tipispuneklimakomore: _first_item.tipispuneklimakomore,
        vrstaprofila: _first_item.vrstaprofila,
      };
      console.log('draftel _bundle_panel', bundleDraftel);
      bundle_arr.push(bundleDraftel);
    }
  });
  console.log('CODEC output BUNDLES bundle_arr');
  console.log(bundle_arr);
  return bundle_arr;
};

